import React, { useEffect, useRef, useState } from "react";

const FALLBACK_CHROME_HEIGHT = 72;

const chromeHeight = () => {
  if (typeof window === "undefined") return FALLBACK_CHROME_HEIGHT;

  const value = getComputedStyle(document.documentElement).getPropertyValue(
    "--app-header-height"
  );

  return parseInt(value, 10) || FALLBACK_CHROME_HEIGHT;
};

const DetailScaffold = ({
  title,
  hero,
  heroFoot,
  full,
  heroHeight = 320,
  heroAuto = false,
  triggerOffset = 80,
  actions,
  children,
  fadeTitle = true,
  showTitle = true,
  layout = "split",
}) => {
  const sentinelRef = useRef(null);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || typeof IntersectionObserver !== "function") return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setStuck(!entry.isIntersecting),
      { threshold: 0, rootMargin: `-${chromeHeight()}px 0px 0px 0px` }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  const barIsEmpty = !showTitle && !actions;

  const bar = (
    <header
      className={`sy-detail-bar${stuck ? " is-stuck" : ""}${
        barIsEmpty ? " is-empty" : ""
      }`}
    >
      {showTitle && (
        <h1
          className={`sy-detail-bar-title${
            fadeTitle && !heroAuto && !stuck ? " is-hidden" : ""
          }`}
        >
          {title}
        </h1>
      )}

      <div className="sy-detail-bar-actions">{actions}</div>
    </header>
  );

  return (
    <div
      className={`sy-detail sy-detail-${layout} full-bleed${
        heroAuto ? " has-flow-hero" : ""
      }`}
      style={{ "--sy-hero-height": `${heroHeight}px` }}
    >
      {heroAuto && bar}

      <div className={`sy-detail-hero${heroAuto ? " is-auto" : ""}`}>{hero}</div>

      {heroFoot && <div className="sy-detail-herofoot">{heroFoot}</div>}

      <div
        ref={sentinelRef}
        className="sy-detail-sentinel"
        style={{ top: `${heroHeight - triggerOffset}px` }}
        aria-hidden="true"
      />

      {!heroAuto && bar}

      <div className="sy-detail-body">{children}</div>

      {full && <div className="sy-detail-full">{full}</div>}
    </div>
  );
};

export default DetailScaffold;
